import { useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

const T = {
  bg: "#0b0c10", card: "#1c1d26", border: "#2e2f42",
  accent: "#e8ff00", text: "#eeeeff", muted: "#6b6c88", red: "#ff4455",
};

// Borra TODO lo relacionado a la PWA vieja (service workers + cachés) sin necesitar DevTools.
// Funciona desde el celular también, ya que corre puramente en JavaScript dentro de la app.
async function forceFullReset() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }
  } catch (e) {
    console.error('Error al limpiar caché:', e);
  }
  // Recarga forzando bypass de caché con un parámetro único
  window.location.href = window.location.pathname + '?v=' + Date.now();
}

export default function UpdatePrompt() {
  const [updating, setUpdating] = useState(false);
  const [showForceOption, setShowForceOption] = useState(false);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      if (registration) {
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update();
          }
        });
        setInterval(() => registration.update(), 60 * 60 * 1000);
      }
    },
  });

  const handleUpdate = async () => {
    setUpdating(true);
    try {
      await updateServiceWorker(true);
    } catch (e) {
      console.error(e);
    }
    // Si en 2.5s la página no se recargó sola (updateServiceWorker debería recargarla),
    // ofrecemos la opción de forzado manual.
    setTimeout(() => setShowForceOption(true), 2500);
  };

  if (!needRefresh) return null;

  return (
    <div style={{
      position: "fixed", bottom: "calc(70px + env(safe-area-inset-bottom))",
      left: 12, right: 12, zIndex: 9999,
      background: T.card, border: `1px solid ${T.accent}55`,
      borderRadius: 14, padding: "14px 16px",
      display: "flex", flexDirection: "column", gap: 10,
      boxShadow: "0 8px 24px rgba(0,0,0,.4)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ fontSize: 22, flexShrink: 0 }}>✨</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 15, color: T.accent, letterSpacing: ".04em" }}>
            NUEVA VERSIÓN DISPONIBLE
          </div>
          <div style={{ fontSize: 12, color: T.muted, marginTop: 2 }}>
            {updating ? "Actualizando..." : "Actualizá para ver las últimas mejoras"}
          </div>
        </div>
        <button
          onClick={handleUpdate}
          disabled={updating}
          style={{
            background: T.accent, color: "#000", border: "none", borderRadius: 8,
            padding: "9px 16px", fontSize: 13, fontWeight: 700,
            cursor: updating ? "default" : "pointer", flexShrink: 0,
            opacity: updating ? 0.6 : 1,
          }}
        >
          {updating ? "..." : "Actualizar"}
        </button>
        {!updating && (
          <button
            onClick={() => setNeedRefresh(false)}
            style={{
              background: "none", color: T.muted, border: "none", fontSize: 18,
              cursor: "pointer", flexShrink: 0, padding: "0 2px",
            }}
          >
            ×
          </button>
        )}
      </div>

      {showForceOption && (
        <div style={{ borderTop: `1px solid ${T.border}`, paddingTop: 10 }}>
          <p style={{ fontSize: 11, color: T.muted, marginBottom: 8, lineHeight: 1.4 }}>
            ¿No pasó nada al tocar Actualizar? Probá el reinicio completo — borra el caché viejo de la app.
          </p>
          <button
            onClick={forceFullReset}
            style={{
              width: "100%", background: T.red + "22", color: T.red,
              border: `1px solid ${T.red}55`, borderRadius: 8,
              padding: "9px 0", fontSize: 12, fontWeight: 700, cursor: "pointer",
            }}
          >
            🔄 Forzar actualización completa
          </button>
        </div>
      )}
    </div>
  );
}
